/* Progressive enhancement only. The complete evidence table is server-rendered. */
(() => {
  const root = document.querySelector('.ers-rice-benchmark');
  const controls = root?.querySelector('[data-benchmark-controls]');
  const body = root?.querySelector('#compact-benchmark-table tbody');
  if (!controls || !body) return;
  const rows = [...body.rows];
  const search = controls.querySelector('input');
  const order = controls.querySelector('select');
  const count = controls.querySelector('[data-benchmark-count]');
  const fields = {dry:'tested_raw_mass_g_mean', usable:'usable_output_g_mean', ready:'service_ready_min_mean', rate:'service_ready_output_kg_hr_mean'};
  const value = (row, key) => Number(row.querySelector(`[data-metric="${fields[key]}"]`).textContent.replaceAll(',', ''));
  function update() {
    const term = search.value.trim().toLocaleLowerCase();
    const ordered = order.value === 'source' ? rows : [...rows].sort((a,b) => value(a,order.value)-value(b,order.value));
    let visible = 0;
    ordered.forEach(row => {
      row.hidden = !row.textContent.toLocaleLowerCase().includes(term);
      if (!row.hidden) visible++;
      body.append(row);
    });
    count.textContent = `${visible} of ${rows.length} configurations shown`;
  }
  controls.hidden = false;
  search.addEventListener('input',update);
  order.addEventListener('change',update);
  update();
})();
